var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarExpand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.7 4.8C5.20294 4.8 4.8 5.20294 4.8 5.7V18.3C4.8 18.7971 5.20294 19.2 5.7 19.2H18.3C18.7971 19.2 19.2 18.7971 19.2 18.3V5.7C19.2 5.20294 18.7971 4.8 18.3 4.8H5.7ZM5.7 3H18.3C19.7912 3 21 4.20881 21 5.7V18.3C21 19.7912 19.7912 21 18.3 21H5.7C4.20881 21 3 19.7912 3 18.3V5.7C3 4.20881 4.20881 3 5.7 3Z",
    fill: "#D8D6D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3.9C8 3.40294 8.44771 3 9 3C9.55229 3 10 3.40294 10 3.9V20.1C10 20.5971 9.55229 21 9 21C8.44771 21 8 20.5971 8 20.1V3.9Z",
    fill: "#D8D6D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2929 9.29289C11.9024 9.68342 11.9024 10.3166 12.2929 10.7071L13.5858 12L12.2929 13.2929C11.9024 13.6834 11.9024 14.3166 12.2929 14.7071C12.6834 15.0976 13.3166 15.0976 13.7071 14.7071L15.7071 12.7071C16.0976 12.3166 16.0976 11.6834 15.7071 11.2929L13.7071 9.29289C13.3166 8.90237 12.6834 8.90237 12.2929 9.29289Z",
    fill: "#D8D6D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarExpand);
export default __webpack_public_path__ + "static/media/sidebar-expand.b67adf98d9530e4be05cdf5e30a09f68.svg";
export { ForwardRef as ReactComponent };